import { Injectable } from '@angular/core';

/**
 * Service to interact with the window object.
 */

export class WindowService {

  get nativeWindow(): any {
    return _window();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

function _window(): any {
  // Return the global native browser window object
  return typeof window !== 'undefined' ? window : undefined;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
